import SiteReference from '@/models/SiteReference';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import api from '@/api/api';
import CoordinatePair from '@/models/CoordinatePair';
import SearchResult from '@/models/SearchResult';
import { SearchType } from '@/models/SearchType';

@Module
export default class MapSearchResults extends VuexModule {
  currentSearch = <SearchResult> {
    siteRefs: new Array<SiteReference>(),
    searchTerms: new Array<string>(),
    searchType: SearchType.Map
  };

  @Mutation
  setMapSearchResults(currentSearch: SearchResult) {
    this.currentSearch = currentSearch;
  }

  @Action({ commit: 'setMapSearchResults' })
  // TODO: types... 
  async doMapSearch({ southwestBound,                 northeastBound,                 centerPoint }: 
                    { southwestBound: CoordinatePair, northeastBound: CoordinatePair, centerPoint: CoordinatePair }) {
    const siteRefs = await api.getSitesForBounds(southwestBound, northeastBound);
    return {
      siteRefs,
      searchTerms: [`(${centerPoint.lng}, ${centerPoint.lat})`],
      searchType: SearchType.Map
    };
  }
}
